import React from 'react';

import Question from '../elements/question';
import Feedback from '../elements/feedback';
import {InfoBox, WarningBox} from '../elements/infoboxes'
import Icon from '../elements/icon';
import state from '../zviz3/state';
import {ConnectState} from '../zviz3/Connect';

const questions = [
    {
        name: 'a1',
        question: 'Is de woning in eigendom van u zelf?',
        explanation: null,
        options: [
            {value: true, label: 'Ja'},
            {value: false, label: 'Nee'}
        ],
        conditions: [ ]
    },
    {
        name: 'a2',
        question: 'Is de woning uw hoofdverblijf?',
        explanation: 'Een woning is uw hoofdverblijf, als het uw centrale levensplaats is. Dat is de plaats dat het middelpunt is van uw persoonlijke en economische belangen.',
        options: [
            {value: true, label: 'Ja'},
            {value: false, label: 'Nee'}
        ],
        conditions: [
            {variable: 'a1', value: true, type: 'equal'}
        ]
    },
    {
        name: 'a3',
        question: 'Wordt de woning uw hoofdverblijf direct na de renovatie waarvoor deze subsidie is aangevraagd?',
        explanation: null,
        options: [
            {value: true, label: 'Ja'},
            {value: false, label: 'Nee'}
        ],
        conditions: [
            {variable: 'a2', value: false, type: 'equal'}
        ]
    },
    {
        name: 'a4',
        question: 'Selecteer uw woningtype',
        explanation: null,
        options: [
            {value: 'vrijstaand', label: 'Vrijstaande woning'},
            {value: 'halfvrijstaand', label: '2-onder-1kap of half vrijstaande woning'},
            {value: 'tussenwoning', label: 'Tussenwoning'},
            {value: 'etagewoning', label: 'Etagewoning'}
        ],
        conditions: [
            {variable: 'a2', value: true, type: 'equal'},
            {variable: 'a3', value: true, type: 'equal'},
        ]
    },
    {
        name: 'a5',
        question: 'Heeft u of de vorige bewoner van deze woning eerder subsidie ontvangen op grond van deze regeling?',
        explanation: null,
        options: [
            {value: true, label: 'Ja'},
            {value: false, label: 'Nee'}
        ],
        conditions: [
            {variable: 'a4', value: null, type: 'not_equal'}
        ]
    },
    // {
    //     name: 'a6',
    //     question: 'Heeft u minimaal 2 energiebesparende maatregelen uitgevoerd aan uw woning?',
    //     explanation: 'Energiebesparende maatregelen voor deze subsidie zijn: gevelisolatie, vloer- en/of bodemisolatie, dakisolatie of hoogrendementsglas.',
    //     options: [
    //         {value: true, label: 'Ja'},
    //         {value: false, label: 'Nee'}
    //     ],
    //     conditions: [
    //         {variable: 'a5', value: false, type: 'equal'}
    //     ]
    // },
    {
        name: 'a6',
        question: 'Selecteer hieronder de energiebesparende maatregelen die u heeft getroffen of gaat treffen.',
        explanation: 'Energiebesparende maatregelen voor deze subsidie zijn: gevelisolatie, vloer- en/of bodemisolatie, dakisolatie of hoogrendementsglas. Hiervan moet u er minimaal 2 uitvoeren om in aanmerking te komen voor deze subsidieregeling.',
        options: [
            {value: 'muur', label: 'Isoleren van muren'},
            {value: 'dak', label: 'Isoleren van het dak'},
            {value: 'vloer', label: 'Isoleren van vloer of bodem'},
            {value: 'glas', label: 'Hoogrendementsglas'},
        ],
        multiselect: true,
        minSelect: 2,
        conditions: [
            {variable: 'a5', value: false, type: 'equal'}
        ]
    },
]

const feedback = [
    {
        content: <InfoBox text="Uw woning komt mogelijk in aanmerking voor subsidie" />,
        name: 'a',
        value: true,
        conditions: [
            {variable: 'a6', value: null, type: 'not_equal'},
        ]    
    },
    {
        content: <WarningBox text="Uw woning komt niet in aanmerking voor subsidie" />,
        name: 'a',
        value: false,
        conditions: [
            {variable: 'a1', value: false, type: 'equal'},
            {variable: 'a3', value: false, type: 'equal'},
            {variable: 'a5', value: true, type: 'equal'},
            {variable: 'a6', value: false, type: 'equal'}
        ]    
    },
    {
        content: <WarningBox text="Let op: u moet minimaal 2 van bovengenoemde energiebesparende maatregelen doorvoeren om in aanmerking te komen voor subsidie." />,
        name: 'a',
        value: false,
        conditions: [
            {type: 'and', conditions: [
                {variable: 'a5', value: false, type: 'equal'},
                {variable: 'a6', value: null, type: 'equal'}
            ]}
        ] 
    }
];

let lastMaatregelen = [];
const checkState = function(){
    const maatregelen = state.get('answers.a6');
    if(maatregelen === null){
        state.set('answers.b', null);
        state.set('answers.c', null);
        state.set('answers.d', null);
        state.set('answers.e', null);
    }else{
        const sections = {b: 'muur', c: 'dak', d: 'vloer', e: 'glas'};
        for(const s of Object.keys(sections)){
            if(maatregelen.indexOf(sections[s]) === -1){
                // make sure user can skip the section it didn't select
                state.set('answers.'+s, true);
            }else if(lastMaatregelen.indexOf(sections[s]) === -1){
                // newly selected option, reset the value
                state.set('answers.'+s, null);
            }
        }
    }
    if(maatregelen){
        lastMaatregelen = maatregelen.slice();
    }
}

export default ConnectState(function (props){

    setTimeout(checkState, 15);

    return <div className="seehi_section">
        <h2 className="seehi_iconHeader"><Icon type="woning" />Uw woning</h2>
        <p>De mogelijkheden voor subsidie is afhankelijk van het woningtype. Geef hier eerst wat informatie over uw woning.</p>

        {questions.map((props, i) => ( <Question key={i} {...props} /> ))}
    
        {feedback.map((props, i) => ( <Feedback key={i} {...props} /> ))}
        
    </div>;
}, 'answers.a6');



// WEBPACK FOOTER //
// ./src/sections/a.js